module.exports = __webpack_public_path__ + "static/media/2.33e3ef2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/02/projects/01/2.jpg
// module id = 404
// module chunks = 0